// SP-2 — query-key factory for the staff statement lifecycle + Monthly Cycle
// Cockpit (stale-after-save convention: queryKey arrays live only in *Keys
// files). Statement mutations (generate / send-to-TPS / regenerate) invalidate
// statementsPrefix + the loan's monthlyCyclePrefix; recording/reversing a
// servicing payment additionally invalidates the servicing ledger + loan
// health via the invalidation helpers.

export const loanStatementsKeys = {
  /** Prefix covering every statement read (queues + per-loan lists). */
  statementsPrefix: () => ["portfolio-admin", "loan-statements"] as const,
  forLoan: (loanId: string) =>
    ["portfolio-admin", "loan-statements", "loan", loanId] as const,
  detail: (statementId: string) =>
    ["portfolio-admin", "loan-statements", "detail", statementId] as const,
  /** WS3 — the B3 review-screen payload for one statement. */
  review: (statementId: string) =>
    ["portfolio-admin", "loan-statements", "review", statementId] as const,
  pendingReview: () =>
    ["portfolio-admin", "loan-statements", "pending-review"] as const,
  correctionQueue: () =>
    ["portfolio-admin", "loan-statements", "correction-queue"] as const,
};

export const monthlyCycleKeys = {
  /** Per-loan prefix — invalidate this after any cycle-affecting mutation. */
  loanPrefix: (loanId: string) =>
    ["portfolio-admin", "monthly-cycle", loanId] as const,
  cycle: (loanId: string, period?: string) =>
    ["portfolio-admin", "monthly-cycle", loanId, period ?? "current"] as const,
};
